<span *ngIf="header" class="field-header">{{header}}</span> 
<mat-form-field class="form-control" style="width: 100%" [appearance]="appearance">
  <mat-label>{{ label }}</mat-label>
  <input
    type="text"
    [placeholder]="label"
    aria-label="Number"
    matInput
    [ngClass]="header ? 'mt-2' : ''"
    [formControl]="controlName"
    [matAutocomplete]="auto"
    [disabled]="isDisable"
    (blur)="onBlurEvent($event)"
  />
  <mat-icon *ngIf="hasError()" matSuffix color="warn">info</mat-icon>
  <mat-icon *ngIf="!hasError() && !isValid()" color="primary" matSuffix>
    {{icon ? icon : 'search'}}
  </mat-icon>
  <mat-icon *ngIf="isValid()" matSuffix class="icon-success">check_circle</mat-icon>
  <mat-error *ngIf="hasError()">{{ getErrorMessage() }}</mat-error>
  <mat-autocomplete 
    #auto="matAutocomplete" 
    [displayWith]="displayFn"
    (optionSelected)="selectedOption($event.option.value)"
  >
  @if(searchType === 'users') {
    <ng-container>
      <mat-option 
        *ngFor="let option of filteredOptions | async; trackBy: trackByFn" 
        [value]="option" 
        class="px-2 pt-2 m-0 option-list"
      >
        <ng-container *ngIf="option['member Iea #']; else nameOnly">
          <ng-container *ngFor="let key of ['member Iea #', 'name', 'city', 'state','role']">
            <p class="singleLabel p-0 m-0">
              <span class="key txt-upper p-0 m-0" style="font-weight: 500;">{{ key }}: </span>
              <span class="txt-upper p-0 m-0">{{ option[key] || '-' }}</span>
            </p>
          </ng-container>
        </ng-container>
        <ng-template #nameOnly>
          {{ option.name }}
        </ng-template>
      </mat-option>
    </ng-container>
  } @else if(searchType === 'teams') { 

    <ng-container >
      <mat-option 
        *ngFor="let option of filteredOptions | async; trackBy: trackByFn" 
        [value]="option" 
        class="px-2 pt-2 m-0 option-list"
      >
        <ng-container *ngFor="let key of ['team Id', 'team name', 'discipline', 'levels', 'city', 'state']">
          <p class="singleLabel pb-1 m-0">
            <span class="key txt-upper p-0 m-0" style="font-weight: 500;">{{ key }}: </span>
            <span class="txt-upper p-0 m-0">{{ option[key] || '-' }}</span>
          </p>
        </ng-container>
      </mat-option>
    </ng-container>
  } @else if(searchType === 'membership'){

    <ng-container>
      <mat-option 
        *ngFor="let option of filteredOptions | async; trackBy: trackByFn" 
        [value]="option" 
        class="px-2 pt-2 m-0 option-list"
      >
        <ng-container *ngFor="let key of ['id', 'name','email','mobile', 'status', 'subStatus', 'city', 'state', 'role', 'gender']">
          <p class="singleLabel pb-1 m-0">
            <span class="key txt-upper p-0 m-0" style="font-weight: 500;">{{ key }}: </span>
            <span class="txt-upper p-0 m-0">{{ option[key] || '-' }}</span>
          </p>
        </ng-container>
      </mat-option>
    </ng-container>
  } @else if(searchType === 'show'){

    <ng-container>
      <mat-option 
        *ngFor="let option of filteredOptions | async; trackBy: trackByFn" 
        [value]="option" 
        class="px-2 pt-2 m-0 option-list"
      >
        <ng-container *ngFor="let key of ['id', 'name','showId','status', 'coachName', 'teamName', 'startDate', 'endDate', 'Show Start Date', 'Show End Date', 'Show Status', 'Coach Name', 'Team Name']">
          <p class="singleLabel pb-1 m-0" *ngIf="option.hasOwnProperty(key)">
            <span class="key txt-upper p-0 m-0" style="font-weight: 500;">{{ key }}: </span>
            <span class="txt-upper p-0 m-0" *ngIf="['id', 'name','showId','status', 'coachName', 'teamName', 'Show Status', 'Coach Name', 'Team Name'].includes(key)">{{ option[key] || '-' }}</span>
            <span class="txt-upper p-0 m-0" *ngIf="['startDate', 'endDate', 'Show Start Date', 'Show End Date'].includes(key)">{{ (option[key] | date: 'MM/dd/yyyy':'UTC') || '-' }}</span>
          </p>
        </ng-container>
      </mat-option>
    </ng-container>
  }  @else if(searchType === 'showGroup') {
    <ng-container>
      <mat-option 
        *ngFor="let option of filteredOptions | async; trackBy: trackByFn" 
        [value]="option" 
        class="px-2 pt-2 m-0 option-list"
      >
        <ng-container *ngFor="let key of ['id', 'name']">
          <p class="singleLabel pb-1 m-0" *ngIf="option.hasOwnProperty(key)">
            <span class="key txt-upper p-0 m-0" style="font-weight: 500;">{{ key }}: </span>
            <span class="txt-upper p-0 m-0">{{ option[key] || '-' }}</span>
          </p>
        </ng-container>
      </mat-option>
    </ng-container>
  } @else if(searchType === 'mergeAccounts') {
    <ng-container>
      <mat-option 
        *ngFor="let option of filteredOptions | async; trackBy: trackByFn" 
        [value]="option" 
        class="px-2 pt-2 m-0 option-list"
      >
        <ng-container *ngFor="let key of ['id', 'name', 'email', 'mobile', 'membershipId', 'guardianName', 'member Iea #']">
          <p class="singleLabel pb-1 m-0" *ngIf="option.hasOwnProperty(key) && option[key]">
            <span class="key p-0 m-0" style="font-weight: 500;">{{ mergeAccountsKeyMappings[key] }}: </span>
            <span class="p-0 m-0">{{ option[key] || '-' }}</span>
          </p>
        </ng-container>
        <ng-container *ngFor="let key of ['role']">
          <p class="singleLabel pb-1 m-0" *ngIf="option.hasOwnProperty(key) && option[key]">
            <span class="key p-0 m-0" style="font-weight: 500;">{{ mergeAccountsKeyMappings[key] }}: </span>
            <span class="p-0 m-0">{{ option[key] | roleLabel }}</span>
          </p>
        </ng-container>
      </mat-option>
    </ng-container>
  } @else if(searchType === 'teamsRenew') { 

    <ng-container >
      <mat-option 
        *ngFor="let option of filteredOptions | async; trackBy: trackByFn" 
        [value]="option" 
        class="px-2 pt-2 m-0 option-list"
      >
        <ng-container *ngFor="let key of ['Team Id', 'team name', 'discipline', 'city', 'state']">
          <p class="singleLabel pb-1 m-0">
            <span class="key txt-upper p-0 m-0" style="font-weight: 500;">{{ key }}: </span>
            <span class="txt-upper p-0 m-0">{{ option[key] || '-' }}</span>
          </p>
        </ng-container>
      </mat-option>
    </ng-container>
  } @else if(searchType === 'showAward') {
    <ng-container>
      <mat-option 
        *ngFor="let option of filteredOptions | async; trackBy: trackByFn" 
        [value]="option" 
        class="px-2 pt-2 m-0 option-list"
      >
        <ng-container *ngFor="let key of ['id', 'name', 'email', 'mobile', 'membershipId', 'guardianName', 'member Iea #', 'teamId', 'teamName']">
          <p class="singleLabel pb-1 m-0" *ngIf="option.hasOwnProperty(key) && option[key]">
            <span class="key p-0 m-0" style="font-weight: 500;">{{ showAwardsKeyMappings[key] }}: </span>
            <span class="p-0 m-0">{{ option[key] || '-' }}</span>
          </p>
        </ng-container>
        <ng-container *ngFor="let key of ['role']">
          <p class="singleLabel pb-1 m-0" *ngIf="option.hasOwnProperty(key) && option[key]">
            <span class="key p-0 m-0" style="font-weight: 500;">{{ showAwardsKeyMappings[key] }}: </span>
            <span class="p-0 m-0">{{ option[key] | roleLabel }}</span>
          </p>
        </ng-container>
      </mat-option>
    </ng-container>
  }
  </mat-autocomplete>
</mat-form-field>
